import { Button, Divider, Grid, Typography } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ButtonClose from 'components/util/buttonClose/.mixins/buttonClose';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { styles } from './styles';
import ptLocale from 'date-fns/locale/pt-BR';
import React from 'react';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

interface IProps {
  handleCalendarChange: (date: MaterialUiPickersDate | null, value?: string | null) => void;
  handleClose: () => void;
  modalTitle: string;
  value: Date | null;
  minDate?: Date;
  maxDate?: Date;
}

export const DatePickerModal = ({ modalTitle, maxDate, minDate, handleCalendarChange, value, handleClose }: IProps) => {
  const useStyles = styles();
  const classes = useStyles();

  const handleConfirm = () => {
    handleClose();
  };

  return (
    <div
      style={{
        overflowX: 'hidden',
        overflowY: 'hidden'
      }}
    >
      <Typography align="center" className={classes.root}>
        {modalTitle}
        <ButtonClose closeMethod={handleClose} />
      </Typography>
      <Divider />
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptLocale}>
        <KeyboardDatePicker
          id="dt_lancamento"
          variant="static"
          margin="normal"
          label="Início Vigência"
          format="dd/MM/yyyy"
          invalidDateMessage="Data inválida"
          cancelLabel="Cancelar"
          disableToolbar
          onChange={handleCalendarChange}
          value={value}
          minDate={minDate}
          maxDate={maxDate}
          className={classes.textField}
          KeyboardButtonProps={{
            'aria-label': 'change date'
          }}
          InputProps={{
            className: classes.multilineColor
          }}
        />
      </MuiPickersUtilsProvider>
      <Divider />
      <div className={classes.dateLabel}>{moment(value).locale('pt-br').format('dddd[,] DD [de] MMMM [de] YYYY')}</div>
      <Grid container spacing={2} className={classes.footer}>
        <Button variant="contained" color="primary" className={classes.bt_confirmar} onClick={handleConfirm}>
          CONFIRMAR
        </Button>
      </Grid>
    </div>
  );
};
